import { Modal } from "../ui/Modal";
import { Share, PlusSquare, ArrowUpRight } from "lucide-react";
import { Button } from "../ui/Button";

interface IOSInstallSheetProps {
  isOpen: boolean;
  onClose: () => void;
}

export function IOSInstallSheet({ isOpen, onClose }: IOSInstallSheetProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="sm"
      title="Install on iPhone / iPad"
      description="Add Soorgaa to your home screen for full-screen study and offline access."
    >
      <div className="space-y-4 pt-1">
        <div className="space-y-3 text-xs sm:text-sm">
          <div className="flex items-start gap-3 p-3 rounded-md bg-muted/40 border border-border">
            <span className="w-6 h-6 rounded-full bg-primary/10 text-primary font-bold text-xs flex items-center justify-center shrink-0">
              1
            </span>
            <div className="flex-1 text-foreground">
              <p className="font-semibold flex items-center gap-1.5">
                Tap Share <Share size={14} className="text-primary inline" /> in Safari
              </p>
              <p className="text-xs text-muted-foreground mt-0.5">
                Located at the bottom of your screen on iPhone, or top right on iPad.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3 p-3 rounded-md bg-muted/40 border border-border">
            <span className="w-6 h-6 rounded-full bg-primary/10 text-primary font-bold text-xs flex items-center justify-center shrink-0">
              2
            </span>
            <div className="flex-1 text-foreground">
              <p className="font-semibold flex items-center gap-1.5">
                Select &ldquo;Add to Home Screen&rdquo;{" "}
                <PlusSquare size={14} className="text-primary inline" />
              </p>
              <p className="text-xs text-muted-foreground mt-0.5">
                Scroll down in the share sheet to find the option.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3 p-3 rounded-md bg-muted/40 border border-border">
            <span className="w-6 h-6 rounded-full bg-primary/10 text-primary font-bold text-xs flex items-center justify-center shrink-0">
              3
            </span>
            <div className="flex-1 text-foreground">
              <p className="font-semibold flex items-center gap-1.5">
                Tap &ldquo;Add&rdquo; <ArrowUpRight size={14} className="text-primary inline" />
              </p>
              <p className="text-xs text-muted-foreground mt-0.5">
                Top right corner. Soorgaa will install directly to your device.
              </p>
            </div>
          </div>
        </div>

        <div className="pt-2">
          <Button variant="primary" className="w-full" onClick={onClose}>
            Got it
          </Button>
        </div>
      </div>
    </Modal>
  );
}
